import { ThemeProvider } from "@mui/material";
import "./App.css";
import "./assets/styles/fonts.css";
import RouteConfig from "./routes/RouteConfig";
import { globalStyles, theme } from "./theme";
import ToastProvider from "./components/common/ToastProvider";
import { GlobalDataProvider } from "./contexts/GlobalDataContext";
import { setGlobalNavigate } from "./utils/helpers";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function App() {
  const navigate = useNavigate();
  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  // console.log(navigator.onLine , "navigator")
  return (
    <GlobalDataProvider>
      <ToastProvider>
        <ThemeProvider theme={theme}>
          {globalStyles}
          <RouteConfig />
        </ThemeProvider>
      </ToastProvider>
    </GlobalDataProvider>
  );
}

export default App;
